import { getApiUrl } from '../config/api';

const geocodeCache = new Map();

export const fetchGeocode = async (query) => {
  const q = String(query || '').trim();
  if (!q) return null;
  const key = q.toLowerCase();
  if (geocodeCache.has(key)) return geocodeCache.get(key);

  try {
    const res = await fetch(getApiUrl(`/api/geocode/search?q=${encodeURIComponent(q)}`));
    const data = await res.json();
    if (data?.success && data.lat != null && data.lng != null) {
      const coords = { lat: Number(data.lat), lng: Number(data.lng) };
      geocodeCache.set(key, coords);
      return coords;
    }
  } catch {
    /* ignore */
  }
  geocodeCache.set(key, null);
  return null;
};

/** Build best geocode query for a meeting room */
export const buildRoomGeocodeQuery = (room, searchLocation = '') => {
  const parts = [
    room.address,
    room.building,
    room.city,
    room.state,
    room.pincode,
    room.locationLabel || (typeof room.location === 'string' ? room.location : ''),
    searchLocation,
    'India',
  ]
    .map((p) => String(p || '').trim())
    .filter(Boolean);
  const unique = [...new Set(parts)];
  if (room.name && searchLocation) {
    return `${room.name}, ${unique.join(', ')}`;
  }
  return unique.join(', ');
};

/** Offset duplicate coordinates so pins don't stack — golden-angle spiral for large sets */
export const spreadCoordinate = (lat, lng, index, total) => {
  if (total <= 1) return { lat, lng };

  const goldenAngle = Math.PI * (3 - Math.sqrt(5));
  const angle = index * goldenAngle;
  const ring = Math.sqrt(index + 1);
  const maxRadius = Math.min(0.12, 0.015 + Math.sqrt(total) * 0.006);
  const radius = Math.min(0.003 + ring * 0.004, maxRadius);

  return {
    lat: lat + Math.cos(angle) * radius,
    lng: lng + Math.sin(angle) * radius,
  };
};
